export default function formatPrice(price) {
  if (typeof price === 'object') {
    const currency = price.currency || 'USD'
    const formatter = Intl.NumberFormat('en-US', {
      style: 'currency',
      currency
    })
    return formatter.format(price.amount)
  }
  return `${price || ''}`
}
